import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaInnerLoading from './VaInnerLoading.vue'

export const VaInnerLoading = withConfigTransport(_VaInnerLoading)
